import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { env } from "../../../env";
import axios from "axios";
import { logEvent } from "../../../analytics";

const AddQuantityButton = ({row, sendQuantityDataFromChild, staticQuantityArray, popCheck, type, loading}) => {
    const { t } = useTranslation();
    const [quantity, setQuantity] = useState(staticQuantityArray);
    const [loadCheckId, setLoadCheckId] = useState(0);

    useEffect(() => {
        setQuantity(staticQuantityArray);
    }, [staticQuantityArray]);

    useEffect(() => {
        setLoadCheckId(loading);
    }, [loading]);

    const addQuantity = (e) => {
        e.preventDefault();
        setQuantity(parseFloat(quantity) + 1);
        logEvent('create_order_page', 'cart', 'add-quantity', row.b2bline1+'-'+row.item_code+'-quantity:'+(parseFloat(quantity) + 1));
    }

    const subtractQuantity = (e) => {
        e.preventDefault();
        if(parseFloat(quantity) > 0) {
            setQuantity(parseFloat(quantity) - 1);
            logEvent('create_order_page', 'cart', 'remove-quantity', row.b2bline1+'-'+row.item_code+'-quantity:'+(parseFloat(quantity) - 1));
        }
    }

    const getQuantitySuggestion = async(code, qty) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        const requestData = {
            "productcode": code,
            "qty": qty
        }

        await axios.post(baseUrl+`/api/Product/GetNewQty`, requestData, { headers })
        .then((response) => {
            if(response.data.message) {
                var resMessage = response.data.message;
            } else {
                var resMessage = "";
            }
            sendQuantityDataFromChild({'id': row.productid, 'product': row, 'quantity': parseFloat(quantity), 'action': 'add', 'message' : resMessage, 'suggestQty': response.data.newqty });
        }).catch((error) => {
            console.log(error);
        });
    }

    const addItems = (e) => {
        e.preventDefault();
        setLoadCheckId(row.productid);
        if(parseFloat(quantity) > 0) {
            logEvent('create_order_page', 'cart', 'add-proudct-to-cart', row.b2bline1+'-'+row.item_code+'-quantity:'+quantity);
            getQuantitySuggestion(row.item_code, quantity);
        }
    }

    const handleChange = (e) => {
        if(e.target.value >= 0) {
            setQuantity(e.target.value);
            logEvent('create_order_page', 'cart', 'add-quantity', row.b2bline1+'-'+row.item_code+'-quantity:'+(e.target.value));
        }
    }

    return (
        <>
            <div className={(popCheck ? "w-full" : "") + " flex text-base bg-white rounded-lg text-blue-normal border border-blue-normal font-medium justify-between items-center"}>
                <div className="cursor-pointer w-full h-full flex flex-col justify-center items-center py-2 px-3" onClick={(e) => subtractQuantity(e)}>
                    <img src="../../../../assets/icons/minus.svg" alt="minus" />
                </div>
                <div className="w-16 text-center py-2">
                    <input className="focus:outline-none remove-arrow text-center w-16" 
                        type="number" 
                        value={parseFloat(quantity)} 
                        onChange={(e) => handleChange(e)} 
                        onFocus={(e) => e.target.select()}
                        onClick={(e) => e.target.select()}
                    />
                </div>
                <div className="cursor-pointer w-full h-full flex flex-col justify-center items-center py-2 px-3" onClick={(e) => addQuantity(e)}>
                    <img src="../../../../assets/icons/plus.svg" alt="plus" />
                </div>
            </div>
            {((loadCheckId !== row.productid) 
                ? 
                    (popCheck 
                        ?
                            <div onClick={(e) => parseFloat(quantity) > 0 && addItems(e)} type={parseFloat(quantity) === 0 ? "none" : "button"} className={(parseFloat(quantity) == 0 ? 'cursor-not-allowed' : 'cursor-pointer') + " bg-blue-normal text-white flex items-center py-2 px-3 rounded-lg w-full justify-center ml-2"}>
                                <div className="first-letter:capitalize mr-4">{ t("add to cart")}</div>
                                <img src="../../../../assets/icons/table/cart-add-white.svg" alt="add" />
                            </div>
                        :
                            <button onClick={(e) => parseFloat(quantity) > 0 && addItems(e)} type={parseFloat(quantity) === 0 ? "none" : "button"} className={(parseFloat(quantity) == 0 ? 'cursor-not-allowed ml-2' : 'cursor-pointer ml-2') + ((type === 'box') ? " bg-blue-normal rounded-lg py-2 px-3" : "")}>
                                <img src={`../../../../assets/icons/table/cart-add${(type === 'box') ? "-white" : ""}.svg`} alt="add" />
                            </button>
                    )
                :
                    <div className="flex items-center gap-2 text-blue-normal ml-2">
                        <svg className="animate-spin h-5 w-5 text-blue-normal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                    </div>
            )}
        </>
    )
}

export default AddQuantityButton;